import React, { Component } from 'react'
import { Link, Redirect } from 'react-router-dom'
import Config from '../../commons/config/Config.js'
import Security from '../../commons/security/Security.js'
import {
	Collapse, Grid, Box, TextField, MenuItem,
	Table, TableContainer, TableHead, TableBody, TableRow, TablePagination,
	CircularProgress, FormControlLabel, Checkbox,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import UpIcon from '@material-ui/icons/KeyboardArrowUp'
import { StyledTableCell, StyledTooltip } from '../../commons/utils/TableStyles.js'

var ESTADO_STATUS = {
	PROCESANDO: 'processing',
	COMPLETADA: 'completed',
	RECHAZADA:  'rejected',
	FALLIDA:    'error',
}

var ESTADOS = [
	{ value: '',           label: 'Todos'       },
	{ value: 'COMPLETADA', label: 'Completada'  },
	{ value: 'PROCESANDO', label: 'Procesando'  },
	{ value: 'FALLIDA',    label: 'Fallida'     },
	{ value: 'RECHAZADA',  label: 'Rechazada'   },
]

var BADGE = {
	completed:  { cls: 'badge badge-success',   label: 'Completada'  },
	processing: { cls: 'badge badge-warning',   label: 'Procesando'  },
	error:      { cls: 'badge badge-danger',    label: 'Fallida'     },
	rejected:   { cls: 'badge badge-secondary', label: 'Rechazada'   },
}

class EricInspeccionesGrid extends Component {
	constructor(props) {
		super(props)
		this._mounted = false
		this.state = {
			redirectTo:          null,
			loading:             true,
			data:                [],
			total:               0,
			kpis:                null,
			page:                1,
			perPage:             20,
			dropdownActive:      false,
			filtroEstado:        '',
			filtroPatente:       '',
			filtroDiscrepancia:  false,
			filtroFechaDesde:    '',
			filtroFechaHasta:    '',
			patenteInput:        '',
			reasignandoId:       null,
			movilIdInput:        '',
			reasignandoLoading:  false,
			reasignError:        '',
		}
		this.handleFiltroEstado        = this.handleFiltroEstado.bind(this)
		this.handleFiltroPatente       = this.handleFiltroPatente.bind(this)
		this.handlePatenteKeyDown      = this.handlePatenteKeyDown.bind(this)
		this.handleFiltroDiscrepancia  = this.handleFiltroDiscrepancia.bind(this)
		this.handleFiltroFechaDesde    = this.handleFiltroFechaDesde.bind(this)
		this.handleFiltroFechaHasta    = this.handleFiltroFechaHasta.bind(this)
		this.irAPagina                 = this.irAPagina.bind(this)
		this.iniciarReasignacion       = this.iniciarReasignacion.bind(this)
		this.cancelarReasignacion      = this.cancelarReasignacion.bind(this)
		this.confirmarReasignacion     = this.confirmarReasignacion.bind(this)
	}

	componentWillMount() {
		this._mounted = true
		if (!Security.hasPermission('ERIC_LISTAR')) {
			this.setState({ redirectTo: '/error' })
			return
		}
		this.cargar(1)
	}

	componentWillUnmount() {
		this._mounted = false
	}

	buildQS(page, estado, patente, discrepancia, fechaDesde, fechaHasta) {
		var params = ['page=' + page, 'per_page=' + this.state.perPage]
		if (estado)       params.push('estado='       + encodeURIComponent(estado))
		if (patente)      params.push('patente='      + encodeURIComponent(patente))
		if (discrepancia) params.push('solo_discrepancia=1')
		if (fechaDesde)   params.push('fecha_desde='  + encodeURIComponent(fechaDesde))
		if (fechaHasta)   params.push('fecha_hasta='  + encodeURIComponent(fechaHasta))
		return params.join('&')
	}

	cargar(page) {
		if (!this._mounted) return
		this.setState({ loading: true })
		var component = this
		var s = this.state
		var qs = this.buildQS(page, s.filtroEstado, s.filtroPatente, s.filtroDiscrepancia, s.filtroFechaDesde, s.filtroFechaHasta)

		fetch(Config.get('apiUrlBase') + '/v1/inspections?' + qs, {
			headers: { 'Authorization-Token': localStorage.getItem('token') }
		})
		.then(function(response) {
			if (!component._mounted) return null
			return response.json()
		})
		.then(function(data) {
			if (!component._mounted || !data) return
			component.setState({
				loading: false,
				data:    data.data  || [],
				total:   data.total || 0,
				kpis:    data.kpis  || null,
				page:    page,
			})
		})
		.catch(function() {
			if (component._mounted) component.setState({ loading: false })
		})
	}

	handleFiltroEstado(e) {
		this.setState({ filtroEstado: e.target.value }, function() { this.cargar(1) })
	}

	handleFiltroPatente(e) {
		this.setState({ patenteInput: e.target.value })
	}

	handlePatenteKeyDown(e) {
		if (e.key === 'Enter') {
			this.setState({ filtroPatente: this.state.patenteInput }, function() { this.cargar(1) })
		}
	}

	handleFiltroDiscrepancia(e) {
		this.setState({ filtroDiscrepancia: e.target.checked }, function() { this.cargar(1) })
	}

	handleFiltroFechaDesde(e) {
		this.setState({ filtroFechaDesde: e.target.value }, function() { this.cargar(1) })
	}

	handleFiltroFechaHasta(e) {
		this.setState({ filtroFechaHasta: e.target.value }, function() { this.cargar(1) })
	}

	irAPagina(page) {
		this.cargar(page)
	}

	iniciarReasignacion(id) {
		this.setState({ reasignandoId: id, movilIdInput: '', reasignError: '' })
	}

	cancelarReasignacion() {
		this.setState({ reasignandoId: null, movilIdInput: '', reasignError: '' })
	}

	confirmarReasignacion(e) {
		e.preventDefault()
		var component = this
		var id      = this.state.reasignandoId
		var movilId = parseInt(this.state.movilIdInput, 10)
		if (!movilId || movilId <= 0) {
			this.setState({ reasignError: 'Ingresá un ID de vehículo válido.' })
			return
		}
		this.setState({ reasignandoLoading: true, reasignError: '' })
		fetch(Config.get('apiUrlBase') + '/v1/inspections/' + id + '/reassign', {
			method: 'POST',
			headers: {
				'Authorization-Token': localStorage.getItem('token'),
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ movil_id: movilId }),
		})
		.then(function(response) {
			if (!component._mounted) return null
			return response.json().then(function(body) {
				return { status: response.status, body: body }
			})
		})
		.then(function(res) {
			if (!component._mounted || !res) return
			if (res.status === 200) {
				component.setState({ reasignandoId: null, movilIdInput: '', reasignError: '', reasignandoLoading: false })
				component.cargar(component.state.page)
			} else {
				var msg = res.body && res.body.error ? res.body.error : 'No se pudo reasignar la inspección.'
				component.setState({ reasignError: msg, reasignandoLoading: false })
			}
		})
		.catch(function() {
			if (component._mounted) component.setState({ reasignError: 'Error de conexión.', reasignandoLoading: false })
		})
	}

	renderKpis() {
		var kpis = this.state.kpis
		if (!kpis) return null

		var cards = [
			{
				label: 'Total inspecciones',
				value: kpis.total != null ? kpis.total : 0,
				icon:  'fa fa-camera',
				color: '#607d8b',
			},
			{
				label: 'Con daños detectados',
				value: kpis.con_danios != null ? kpis.con_danios : 0,
				icon:  'fa fa-warning',
				color: '#e55353',
			},
			{
				label: 'Pendientes de revisión',
				value: kpis.procesando != null ? kpis.procesando : 0,
				icon:  'fa fa-clock-o',
				color: '#f39c12',
			},
		]

		return (
			<div className="row mb-2">
				{cards.map(function(card) {
					return (
						<div key={card.label} className="col-md-4">
							<div className="card pull-up">
								<div className="card-content" style={{ borderRadius: '.45rem' }}>
									<div className="card-body" style={{ padding: '15px' }}>
										<div className="text-right">
											<h6 className="text-muted text-bold-500">{card.label}</h6>
										</div>
										<div className="media d-flex">
											<div className="align-self-center mr-3">
												<i className={card.icon} style={{ fontSize: '2.5rem', color: card.color, opacity: 0.8 }}></i>
											</div>
											<div className="media-body text-right">
												<h3 className="text-bold-600" style={{ color: card.color }}>{card.value}</h3>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					)
				})}
			</div>
		)
	}

	renderEstadoBadge(status) {
		var entry = BADGE[status]
		if (!entry) return <span className="badge badge-light">{status}</span>
		return <span className={entry.cls}>{entry.label}</span>
	}

	renderReasignModal() {
		if (this.state.reasignandoId === null) return null
		return (
			<div
				style={{
					position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
					backgroundColor: 'rgba(0,0,0,0.4)', zIndex: 1050,
					display: 'flex', alignItems: 'center', justifyContent: 'center',
				}}
				onClick={this.cancelarReasignacion}
			>
				<div
					className="card"
					style={{ width: '360px', margin: 0 }}
					onClick={function(e) { e.stopPropagation() }}
				>
					<div className="card-header py-2 px-3">
						<strong>Reasignar inspección #{this.state.reasignandoId}</strong>
					</div>
					<form onSubmit={this.confirmarReasignacion}>
						<div className="card-body py-3 px-3">
							<p className="text-muted mb-2" style={{ fontSize: '0.85rem' }}>
								Ingresá el ID del vehículo correcto para vincular esta inspección.
							</p>
							<div className="form-group mb-2">
								<label style={{ fontSize: '0.8rem' }}>ID de vehículo</label>
								<input
									type="number"
									min="1"
									className="form-control form-control-sm"
									placeholder="Ej: 42"
									value={this.state.movilIdInput}
									onChange={function(e) { this.setState({ movilIdInput: e.target.value, reasignError: '' }) }.bind(this)}
									autoFocus
								/>
							</div>
							{this.state.reasignError && (
								<div className="alert alert-danger py-1 px-2 mb-0" style={{ fontSize: '0.8rem' }}>
									{this.state.reasignError}
								</div>
							)}
						</div>
						<div className="card-footer py-2 px-3 d-flex justify-content-end" style={{ gap: '8px' }}>
							<button
								type="button"
								className="btn btn-sm btn-secondary"
								onClick={this.cancelarReasignacion}
								disabled={this.state.reasignandoLoading}
							>Cancelar</button>
							<button
								type="submit"
								className="btn btn-sm btn-primary"
								disabled={this.state.reasignandoLoading}
							>
								{this.state.reasignandoLoading ? 'Guardando...' : 'Confirmar'}
							</button>
						</div>
					</form>
				</div>
			</div>
		)
	}

	render() {
		if (this.state.redirectTo) return <Redirect to={this.state.redirectTo} />

		var component   = this
		var matchUrl    = this.props.match ? this.props.match.url : '/eric'
		var hasFilters  = !!(
			this.state.filtroEstado ||
			this.state.filtroPatente ||
			this.state.filtroDiscrepancia ||
			this.state.filtroFechaDesde ||
			this.state.filtroFechaHasta
		)

		return (
			<div className="content-body">
				{this.renderReasignModal()}

				<div className="content-header row">
					<div className="content-header-left col-12 mb-2">
						<h3 className="content-header-title">
							<i className="fa fa-camera mr-1"></i>
							Eric IA — Detección de Daños
						</h3>
					</div>
				</div>

				{this.renderKpis()}

				<div className="card">
					<div className="card-content collpase show">
						<div className="card-body card-dashboard">

							<div className="container-fluid mb-1">
								<div className="row dt-icons">
									<div className="col">
										<StyledTooltip title={this.state.dropdownActive ? 'Ocultar filtros' : 'Mostrar filtros'} placement="right">
											<div
												className="btn btn-grey-blue box-shadow-2 btn-round btn-lg btn-dt-main round-icon"
												style={{ height: 52 }}
												onClick={() => this.setState({ dropdownActive: !this.state.dropdownActive })}
											>
												{this.state.dropdownActive ? <UpIcon /> : <ExpandMoreIcon />}
											</div>
										</StyledTooltip>
									</div>
									<div className="col">
										{hasFilters && (
											<div className="btn-dt-main round-icon">
												<div
													className="text-center"
													style={{
														height: '25px',
														borderRadius: '3px',
														display: 'flex',
														justifyContent: 'center',
														alignItems: 'center',
														paddingLeft: '8px',
														backgroundColor: '#5AAC43',
														color: 'white',
													}}
												>
													<div style={{ width: '100%', fontSize: '12px', fontWeight: '500' }}>
														{this.state.total} resultado{this.state.total !== 1 ? 's' : ''} de búsqueda
													</div>
													<div className="resultados-busqueda-notif">
														<i
															className="las la-times la-xs cursor-pointer"
															onClick={() => this.setState({
																filtroEstado: '', filtroPatente: '', filtroDiscrepancia: false,
																filtroFechaDesde: '', filtroFechaHasta: '', patenteInput: '',
															}, () => this.cargar(1))}
														></i>
													</div>
												</div>
											</div>
										)}
									</div>
								</div>
							</div>

							<Collapse in={this.state.dropdownActive} style={{ marginBottom: 20 }}>
								<Grid container item xs={12} spacing={3} className="filtros">
									<Grid component={Box} item xs={3}>
										<TextField
											select
											label="Estado"
											value={this.state.filtroEstado}
											onChange={this.handleFiltroEstado}
											className="col-12"
										>
											{ESTADOS.map(function(e) {
												return <MenuItem key={e.value} value={e.value}>{e.label}</MenuItem>
											})}
										</TextField>
									</Grid>
									<Grid component={Box} item xs={3}>
										<TextField
											label="Patente"
											value={this.state.patenteInput}
											onChange={this.handleFiltroPatente}
											onKeyDown={this.handlePatenteKeyDown}
											placeholder="Enter para buscar"
											className="col-12"
										/>
									</Grid>
									<Grid component={Box} item xs={3}>
										<TextField
											label="Desde"
											type="date"
											value={this.state.filtroFechaDesde}
											onChange={this.handleFiltroFechaDesde}
											className="col-12"
											InputLabelProps={{ shrink: true }}
										/>
									</Grid>
									<Grid component={Box} item xs={3}>
										<TextField
											label="Hasta"
											type="date"
											value={this.state.filtroFechaHasta}
											onChange={this.handleFiltroFechaHasta}
											className="col-12"
											InputLabelProps={{ shrink: true }}
										/>
									</Grid>
									<Grid component={Box} item xs={12}>
										<FormControlLabel
											control={
												<Checkbox
													checked={this.state.filtroDiscrepancia}
													onChange={this.handleFiltroDiscrepancia}
													color="primary"
												/>
											}
											label="Solo con discrepancia de patente"
										/>
									</Grid>
								</Grid>
							</Collapse>

							<TableContainer>
								<Table aria-label="inspecciones" className="table-hover">
									<TableHead>
										<TableRow>
											<StyledTableCell>#</StyledTableCell>
											<StyledTableCell>Estado</StyledTableCell>
											<StyledTableCell>Patente</StyledTableCell>
											<StyledTableCell>Marca / Modelo</StyledTableCell>
											<StyledTableCell>VIN</StyledTableCell>
											<StyledTableCell>Odómetro</StyledTableCell>
											<StyledTableCell>Formulario</StyledTableCell>
											<StyledTableCell>Daños</StyledTableCell>
											<StyledTableCell>Fecha</StyledTableCell>
											<StyledTableCell></StyledTableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{this.state.loading ? (
											<TableRow>
												<StyledTableCell colSpan={10} align="center" style={{ padding: '32px' }}>
													<CircularProgress />
												</StyledTableCell>
											</TableRow>
										) : this.state.data.length === 0 ? (
											<TableRow>
												<StyledTableCell colSpan={10} align="center">
													No se encontraron inspecciones.
												</StyledTableCell>
											</TableRow>
										) : (
											this.state.data.map(function(row) {
												var status         = ESTADO_STATUS[row.estado] || 'processing'
												var discrepancia   = !!row.flag_patente_discrepancia
												var movilPatente   = row.movil_patente   || null
												var inspecPatente  = row.vehiculo_patente || null
												var plateDiff      = movilPatente && inspecPatente &&
													movilPatente.toUpperCase() !== inspecPatente.toUpperCase()
												return (
													<TableRow key={row.id}>
														<StyledTableCell>{row.id}</StyledTableCell>
														<StyledTableCell>{component.renderEstadoBadge(status)}</StyledTableCell>
														<StyledTableCell>
															{movilPatente || inspecPatente || '—'}
															{plateDiff && (
																<StyledTooltip
																	title={'Inspección detectó: ' + inspecPatente}
																	placement="right"
																>
																	<span className="ml-1 badge badge-warning" style={{ cursor: 'default' }}>
																		<i className="fa fa-exclamation-triangle mr-1"></i>
																		{inspecPatente}
																	</span>
																</StyledTooltip>
															)}
															{!plateDiff && discrepancia && status !== 'processing' && (
																<span
																	className="ml-1 badge badge-warning"
																	title="Discrepancia de patente — el vehículo no coincide"
																>
																	<i className="fa fa-exclamation-triangle"></i>
																</span>
															)}
														</StyledTableCell>
														<StyledTableCell>
															{[row.vehiculo_marca, row.vehiculo_modelo].filter(Boolean).join(' ') || '—'}
														</StyledTableCell>
														<StyledTableCell>
															{row.vehiculo_vin ? (
																<span>
																	{row.vehiculo_vin}
																	{row.vin_problema && (
																		<StyledTooltip title="Discrepancia de VIN detectada" placement="right">
																			<span className="ml-1 badge badge-warning" style={{ cursor: 'default' }}>
																				<i className="fa fa-exclamation-triangle"></i>
																			</span>
																		</StyledTooltip>
																	)}
																</span>
															) : '—'}
														</StyledTableCell>
														<StyledTableCell>
															{row.vehiculo_km !== null && row.vehiculo_km !== undefined ? (
																<span>
																	{Math.round(row.vehiculo_km).toLocaleString()} km
																	{row.odometro_problema && (
																		<StyledTooltip title="Discrepancia de odómetro detectada" placement="right">
																			<span className="ml-1 badge badge-warning" style={{ cursor: 'default' }}>
																				<i className="fa fa-exclamation-triangle"></i>
																			</span>
																		</StyledTooltip>
																	)}
																</span>
															) : '—'}
														</StyledTableCell>
														<StyledTableCell>{row.formulario_id || '—'}</StyledTableCell>
														<StyledTableCell>
															{row.danios_count > 0 ? (
																<span className="badge badge-danger">{row.danios_count}</span>
															) : status === 'processing' ? (
																<span className="text-muted" title="Pendiente — inspección en proceso">
																	<i className="fa fa-clock-o"></i>
																</span>
															) : (
																<span className="text-muted">0</span>
															)}
														</StyledTableCell>
														<StyledTableCell>
															{row.created_at ? row.created_at.substring(0, 10) : '—'}
														</StyledTableCell>
														<StyledTableCell style={{ whiteSpace: 'nowrap' }}>
															{discrepancia && status !== 'processing' && Security.hasPermission('ERIC_MODIFICAR') && (
																<StyledTooltip title="Reasignar al vehículo correcto" placement="left">
																	<button
																		className="btn btn-sm btn-warning mr-1"
																		onClick={function() { component.iniciarReasignacion(row.id) }}
																	>
																		<i className="fa fa-exchange"></i>
																	</button>
																</StyledTooltip>
															)}
															<StyledTooltip title="Ver detalle" placement="left">
																<Link
																	to={matchUrl + '/' + row.id}
																	className="btn btn-sm btn-outline-primary"
																>
																	<i className="fa fa-eye"></i>
																</Link>
															</StyledTooltip>
														</StyledTableCell>
													</TableRow>
												)
											})
										)}
									</TableBody>
								</Table>
							</TableContainer>

							<TablePagination
								rowsPerPageOptions={[10, 20, 50]}
								component="div"
								count={this.state.total}
								rowsPerPage={this.state.perPage}
								page={this.state.page - 1}
								onPageChange={function(e, newPage) { component.irAPagina(newPage + 1) }}
								onRowsPerPageChange={function(e) {
									component.setState({ perPage: parseInt(e.target.value, 10), page: 1 }, function() {
										component.cargar(1)
									})
								}}
								labelRowsPerPage="Mostrar"
								labelDisplayedRows={function(obj) {
									return 'Mostrando ' + obj.from + ' a ' + obj.to + ' de ' + obj.count
								}}
							/>

						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default EricInspeccionesGrid
